module.exports = __webpack_public_path__ + "static/media/ic-menu-active.72fa70b9.svg";